import { render, staticRenderFns } from "./RightSideNav.vue?vue&type=template&id=5810e418"
import script from "./RightSideNav.ts?vue&type=script&lang=ts&external"
export * from "./RightSideNav.ts?vue&type=script&lang=ts&external"
import style0 from "./RightSideNav.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports